var site = site || {};
site.inits = [];

site.nav = {};
site.division = {};

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.nav = {
	// Init navigation scripts
	init: function() {
			// Add expand link to mobile menu
		$('.children', '#mMenu').prepend('<span class="expand" ><i class="fa fa-angle-down"></i></span>');
		$('.selectedLevel1,.selectedLevel2,.selectedLevel3,.selectedLevel4,.selectedLevel5','#mMenu').addClass('down');
		$('#mMenu .mmLevel2').wrapInner('<div class="dropWrap" />');
		$('#mMenu .level1.children > a').click(function(e) {
			$('body').toggleClass('dd-open');
			$parent = $(this).parent();
			$parent.toggleClass('dd');
			$parent.find('.mmLevel2').toggleClass('dd');
		});

		$('#mainmenu .mmLevel1 > li.level1').each(function() {
			$li = $(this).clone();
			$li.find('ul').remove();
			if(($(this).find('ul').length)) {
				$(this).children('ul').prepend($li);
			} else {
				$(this).addClass('singleItem');
			}

		});
		site.nav.bind();
		site.nav.appendLanguage();
	},

	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click', function(e) {
			e.preventDefault();
			var $parent = $(this).parent();
			$parent.toggleClass('down');
		});

		$('#mainmenu .mmLevel1 > li.level1 > a').click(function(e) {
			if(!$(this).parent().hasClass('singleItem'))	{
				e.preventDefault();
				$wasActive = $(this).parent('li.level1').hasClass('hover');
				$('#mainmenu .mmLevel1 > li.level1').removeClass('hover');
				$(this).parent('li.level1').toggleClass('hover', !$wasActive);
			}
		});
	},
			// Toggle mobile menu
	mobileToggle: function(e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		if (!menuOpen) {
			$(window).scrollTop(0);
		} else {
			$(window).scrollTop(scrollPosition);
		}
	},
	// Append language to mobilemenu
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			if(!$(this).hasClass('selected')) {
				var $li = $(this).clone();
				$html.append($li.find('a'));
			}
		});

		$menu.append($html);
	}
};

site.division.init = function() {
        var lis = $('#divisions ul li').clone().addClass('division');
        $('.mmLevel1', '#mainmenu').append(lis);
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.division.init();
	site.nav.init();
	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});
});
